<template>
    <div>
        <el-form  ref="ruleForm"  label-width="110px" size="mini">
            <el-form-item   label="业务ID">
                <span>{{formData.i_pid}}</span>
            </el-form-item>
            <el-form-item   label="时间">
                <span>{{formData.dt_createtime}}</span>

            </el-form-item>
            <el-form-item label="响应平台">
                <span>{{formData.vc_resplat}}</span>

            </el-form-item>
            <el-form-item   label="队列名">
                <span>{{formData.vc_queue}}</span>

            </el-form-item>
            <el-form-item  label="队列业务类型">
                <span>{{formData.vc_type}}</span>
            </el-form-item>
            <el-form-item  label="请求的数据">
                <span class="json_data">{{formData.json_data}}</span>
            </el-form-item>
            <el-form-item  label="返回的状态">
                <span v-if="formData.i_state_mq==0"  class="dib yellow">待发送</span>
                <span v-if="formData.i_state_mq==1"  class="dib green">成功</span>
                <span v-if="formData.i_state_mq==-1" class="dib red">失败</span>
            </el-form-item>
            <el-form-item  label="返回的信息">
                <span>{{formData.vc_note}}</span>
            </el-form-item>

        </el-form>
        <div class="center" >
            <el-button type="primary" size="mini" @click="close">取消</el-button>
        </div>

    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'BusinessEntry',
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data(){
            return{
                formData:{},
               
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            this.$nextTick(()=>{
                this.onResize();
            })
            this.getMqDetail()

        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-178

            },
            //消费服务下拉查询
            async getMqDetail() {
                let params = {
                    i_id:this.data.i_id
                }
                let res = await API.getMqDetail(params);
                if (res.code == 1) {
                    this.formData=res.data
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
             close(){
                 this.$emit('close')
            },
        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    .center{
        text-align: center;
    }
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .yellow{
        color: #ffbe06;
    }
    .json_data{
        max-height: 230px;
        overflow-y: auto;
        display: inline-block;
    }
</style>